import { jsxs, jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { Badges } from '../Badges/index.js';
import { PromoBadge } from '../PromoBadge/index.js';
import { FavoriteButton } from '../FavButton/index.js';
import { SoldBadge } from '../SoldBadge/index.js';
import { getItemAvailability } from '../../utils/features.js';
import { CounterWatermark } from './CounterWatermark.js';
import { Placeholder } from './Placeholder.js';
import styles from './index.module.scss.js';

const YAMS_RULE_MAP = {
    '1': 'card-desktop-new-small',
    '4/5': 'vertical-mini-card',
    '3/2': 'large-fixed-card',
};
const getSources = (base, aspectRatio) => {
    const rule = YAMS_RULE_MAP[aspectRatio];
    return {
        src: `${base}?rule=${rule}-1x-auto`,
        srcSet: `${base}?rule=${rule}-1x-auto 1x, ${base}?rule=${rule}-2x-auto 2x, ${base}?rule=${rule}-3x-auto 3x`,
    };
};
const ItemPicture = ({ item, aspectRatio = '1', width, className, lazyLoad = true, disableFavourite = false, assetsBase, }) => {
    const imageContainerStyle = width
        ? {
            '--image-width': `${width}px`,
        }
        : undefined;
    const isGallerized = item.gallerized;
    const isUrgent = item.visibilityOptions?.urgent;
    const isAvailable = getItemAvailability(item);
    const isSold = !isAvailable;
    return (jsxs("div", { className: cn(styles.container, styles[`ratio-${aspectRatio}`], className), style: imageContainerStyle, children: [jsx(ImageOrPlaceholder, { item: item, aspectRatio: aspectRatio, lazyLoad: lazyLoad, isSold: isSold, assetsBase: assetsBase }), isSold ? jsx(SoldBadge, {}) : jsx(PromoBadge, { item: item }), jsx(Badges, { isGallerized: isGallerized, isUrgent: isUrgent }), jsx(CounterWatermark, { images: item.images, hidden: isGallerized || isUrgent, assetsBase: assetsBase }), !disableFavourite && isAvailable && jsx(FavoriteButton, { item: item })] }));
};
const ImageOrPlaceholder = ({ item, aspectRatio = '1', lazyLoad, isSold, assetsBase, }) => {
    const firstImageUrl = item.images?.[0]?.cdnBaseUrl;
    return firstImageUrl ? (jsx("img", { ...getSources(firstImageUrl, aspectRatio), alt: item.subject, className: cn(styles.image, {
            [styles.sold]: isSold,
        }), loading: lazyLoad ? 'lazy' : 'eager', decoding: "async" })) : (jsx(Placeholder, { categoryID: item.category.id, subject: item.subject, assetsBase: assetsBase }));
};

export { ItemPicture };
//# sourceMappingURL=index.js.map
